import { getSiteInfo } from '../SiteConfigs.js';

let SITE_INFO = getSiteInfo();

let warning_widget = {};
warning_widget.ad_block_ready_for_check = false;

warning_widget.empty_div = '<div id="warning_empty_div"></div>';
warning_widget.siteName = SITE_INFO['name'];
warning_widget.close_icon = "<a class='close warning_close' href='#'><img src='https://www.realclearpolitics.com/asset/img/close_icon.png' /></a>";
warning_widget.icon = "https://www.realclearpolitics.com/asset/img/Asset_3.png";
warning_widget.info_message = "Our website is partially funded by displaying online advertisements to our visitors. Please consider supporting us by disabling your Ad-Blocker.";

warning_widget.info = "";
warning_widget.footer_pos = 0;
warning_widget.scroll_fix = 0;
warning_widget.active = false;
warning_widget.active_notice = "";

warning_widget.warning_template = function(){
    var warning_ad_block_enabled = readCookie('warning_ad_block_enabled');

    if(!warning_ad_block_enabled){
        if( $('#warning_empty_div').length == 0 ){
            $(this.empty_div).appendTo('body');
        }

        $('#warning_empty_div').html(this.set_message());
        this.event_listeners();
        $('.warning-wrapper').show();
        $('.warning-wrapper').css('display', 'block');
        $('div.overlay').css('z-index', 500).show();
        $('.warning-wrapper .container').css({
            top: '50%',
            transform : 'translateY(-50%)',
        });
        this.set_scroll_settings();
        this.active = true;
        this.active_notice = "ad block message";

        createCookie('warning_ad_block_enabled', 'temp', 5, true);
        _gaq.push(['_trackEvent', 'notices', 'Underlay', 'option: ad block message', null, true]);

        // var body_class = $('body').attr('class');
        // _gaq.push(['_trackEvent', 'AdBlocker', 'adblocker-blocked', 'section: '+body_class, null, true]);
    }

}

warning_widget.set_notifications_sign_up = function(){
    var warning_notif_underlay = readCookie('warning_notif_underlay');

    if(!warning_notif_underlay){

        if( $('#warning_empty_div').length == 0 ){
            $(this.empty_div).appendTo('body');
        }

        $('#warning_empty_div').html(this.set_notification());
        this.event_listeners();
        $('.inline_sign_up_box').css({
            'bottom': '14px',
            'left': '0',
            'right': '0',
        });
        $('.warning-wrapper').show();
        $('.warning-wrapper').css('display', 'block');

        this.set_scroll_settings();
        this.active = true;
        this.active_notice = "notifications sign up";
        createCookie('warning_notif_underlay', 'temp', '12', true);
        _gaq.push(['_trackEvent', 'notices', 'Underlay', 'option: notifications sign up', null, true]);
    }

}

warning_widget.set_newslettter_sign_up = function(){
    var warning_newsletter_underlay = readCookie('warning_newsletter_underlay');

    if(!warning_newsletter_underlay){
        if( $('#warning_empty_div').length == 0 ){
            $(this.empty_div).appendTo('body');
        }

        $('#warning_empty_div').html(this.newsletter_html());

        $('.warning-wrapper').show();
        $('.warning-wrapper').css('display', 'block');
        this.set_scroll_settings();
        this.newsletter_listeners();
        this.event_listeners();
        this.active = true;
        this.active_notice = "newsletter sign up";

        createCookie('warning_newsletter_underlay', 'temp', '12', true);
        _gaq.push(['_trackEvent', 'notices', 'Underlay', 'option: newsletter sign up', null, true]);
    }
}

warning_widget.set_message = function(){
    return "\
    <div class='warning-wrapper'>\
      "+ this.close_icon +"\
      <div class='container'>\
        <div class='image-wrapper'><img src='"+ this.icon +"' /></div>\
        <div class='message-wrapper'><span class='info-message'>"+ this.info_message +"</span></div>\
      </div>\
    </div>";
}

warning_widget.set_notification = function(){
    return "\
    <div class='warning-wrapper notif-wrapper'>\
      "+ this.close_icon +"\
      <div class='container'>\
      "+inline_widget.create_notifs_sign_up_for_warning()+ "\
      </div>\
    </div>";
}

warning_widget.newsletter_html = function(){
    return "\
        <div class='warning-wrapper notif-wrapper'>\
            "+ this.close_icon +"\
            <div class='container'>\
            "+inline_widget.create_news_sign_up()+ "\
            </div>\
        </div>";
}

warning_widget.position_div = function(scrollPosition){
    if (scrollPosition >= this.footer_pos - 15) {
        // If the function is only supposed to fire once
        var footer_height = $('.footer-wrapper').height();
        $('.warning-wrapper').css({'position': 'fixed', 'bottom': footer_height+'px' });
    }else{
        $('.warning-wrapper').css({'position': 'fixed', 'bottom': '0px'});
    }
}

warning_widget.event_listeners = function(){
    $('.warning_close').on('click', function(){
        $('.warning-wrapper').hide();
        $('div.overlay').css('z-index', 1).hide();
        warning_widget.active = false;

        //on close, check how many times it has been closed before
        //if closed three times create cookie to seven days
        //else create cookie for two days
        //warning underlay cookie that applies to all types of underlays

        var underlay_close_click_count = readCookie('underlay_close_click_count');
        var underlay_close_clicks;

        if(!underlay_close_click_count){
            underlay_close_clicks = 1;
        }else{
            underlay_close_clicks = parseInt(underlay_close_click_count) + 1;
        }

        createCookie('underlay_close_click_count', underlay_close_clicks, 365);

        eraseCookie('warning_underlay');

        if(underlay_close_clicks >= 3){
            createCookie('warning_underlay', 'temp', 7);
        }else{
            createCookie('warning_underlay', 'temp', 2);
        }

        _gaq.push(['_trackEvent', 'notices', 'Underlay', 'option: '+warning_widget.active_notice+' close', null, true]);
        return false;
    });

    //change the position of the elemtent when reached to the bottom of the page -150px
    $(window).on('scroll', function() {
        var scrollPosition = $(this).scrollTop() + warning_widget.scroll_fix;
        warning_widget.position_div(scrollPosition);
    });
}

warning_widget.newsletter_listeners = function(){
    var window_width = $(window).width();
    if(window_width <= 415){
        $('.warning-wrapper').css('height', '75px');
        $('.inline_sign_up_box').css({
            top: '-15px',
        });
    }else if(window_width < 1024){
        $('.warning-wrapper').css('height', '100px');
    }


    $(document).on('focus', '.warning-wrapper #list_email', function(){
        var $this = this;
        setTimeout(function(){
            var height = $($this).parents('.inline_sign_up_box').css('height');
            var warning_height = '';
            if(window_width >= 768){
                warning_height = parseInt(height) + 20;
            }else{
                warning_height = parseInt(height) - 30;
            }

            $('.warning-wrapper').css('height', warning_height+'px');
            $('.sign_up_open').css({
                'height' : (height-10) + 'px',
                'position' : 'relative',
                'top' : '-15px',
            });
        },150);
    });
}

warning_widget.set_scroll_settings = function(){

    if($('.footer').length) {

        var footer_pos = $('.footer').offset();
        this.footer_pos = footer_pos.top;
        var window_height = $(window).height();
        this.scroll_fix = window_height - $('.footer-wrapper').height();
    }
}

warning_widget.check_ad_block_status = function(force_check){

    force_check = force_check || false;
    Utils.global_settings.realclear_ad_block_check = null;

    //if it doesn't load it in into the body
    //it will be blocked by ad block plugins
    //then run the ad block checks
    if( force_check == false ){
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "/asset/section/gpt.js?v=4";
        script.id = "adunit-js";
        script.crossOrigin = 'anonymous';
        
        script.onload = function() {

            console.log('ad-block script was loaded successfully');

            if ( document.getElementById('mjiFajjseefh') !== null && document.getElementById('mjiFajjseefh').clientHeight !== 0 ) {

                Utils.global_settings.realclear_ad_block_check = false;
                warning_widget.ad_block_ready_for_check = true;

            }

        }

        script.onerror = function(){
            // on error force check the status of ad block
            //warning_widget.check_ad_block_status(true);
            console.log('No need to try to run this check if there was an error');
            //if there was an error loading it then this means the user had ad-blocker enabled
            //This will only happen if there was an error
            Utils.global_settings.realclear_ad_block_check = true;
            warning_widget.ad_block_ready_for_check = true;

            if(SITE_INFO['name'] == 'politics'){
                checkIfAnalyticsLoaded2();
            }

            if(typeof _gaq != 'undefined') {
                var body_class = $('body').attr('class');
                _gaq.push(['_trackEvent', 'Adblock Tracker', 'Adblocker enabled', 'section: ' + body_class, null, true]);
            }

        }

        document.body.appendChild(script);

    }

}

//if user is referred to site from a newsletter link
//then we don't want to show the underlay for newsletters for a year
warning_widget.check_for_newsletter_referer = function(){
    var utm_campaign = Utils.get_query_param('utm_campaign');
    var utm_medium = Utils.get_query_param('utm_medium');

    if( (utm_campaign !== null && typeof utm_campaign === 'string') && (utm_medium !== null && typeof utm_medium === 'string') ){
        //check if from mailchimp email
        if( /EMAIL_CAMPAIGN/i.test(utm_campaign) && utm_medium === 'email' ){
            //create newseltter cookie to expire in one year
            eraseCookie('warning_newsletter_underlay');
            createCookie('warning_newsletter_underlay', 'From Newsletter', '365', false);
            _gaq.push(['_trackEvent', 'notices', 'Underlay', 'newsletter click: disable notice', null, true]);
        }
    }
}

warning_widget.init = function(){
    $(document).ready(function(){
        warning_widget.set_scroll_settings();
        $(warning_widget.empty_div).appendTo('body');
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },1000);
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },2000);
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },3000);
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },4000);
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },5000);
        setTimeout(function(){
            warning_widget.set_scroll_settings();
        },6000);
    });

    $(window).resize(function(){
        warning_widget.set_scroll_settings();
        $(window).scroll();
    });
}

export default warning_widget;